import { baseApi } from '../baseApi';

import { Customer, CustomerPhoto, ClaimCardRequest, ClaimCardResponse, ReplaceCardResponse } from './Customer';
import { LoyaltyTransactionDetails } from './LoyaltyTransactionDetails';

const loyaltySlice = baseApi
  .enhanceEndpoints({
    addTagTypes: ['Customer'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCustomer: builder.query<Customer, string>({
        keepUnusedDataFor: 60,
        query: (customerId: string) => ({
          url: `/loyalty/${customerId}`,
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: (result) => (result ? [{ type: 'Customer', id: result.id }] : []),
      }),
      getCustomerPhoto: builder.query<CustomerPhoto, number>({
        keepUnusedDataFor: 60,
        query: (customerId: number) => ({
          url: `/loyalty/photo/${customerId}`,
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        forceRefetch: () => true,
      }),
      loyaltyDetails: builder.query<LoyaltyTransactionDetails, number>({
        keepUnusedDataFor: 0,
        query: (transactionId: number) => ({
          url: `/loyalty/details/${transactionId}`,
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
      }),
      claimCard: builder.mutation<ClaimCardResponse | void, { contactId: number; request: ClaimCardRequest }>({
        query: ({ contactId, request }) => ({
          url: `/loyalty/claim-card/${contactId}`,
          method: 'PUT',
          headers: {
            'x-api-version': '1.0',
            'Content-Type': 'application/json',
          },
          body: request,
        }),
        invalidatesTags: (result, error, { contactId }) => [{ type: 'Customer', id: contactId }],
      }),
      replaceCard: builder.mutation<ReplaceCardResponse, { newCardId: number; oldCardId: number }>({
        query: ({ newCardId, oldCardId }) => ({
          url: `/loyalty/replace-card/${newCardId}/${oldCardId}`,
          method: 'POST',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        invalidatesTags: (result, error, { oldCardId }) => [{ type: 'Customer', id: oldCardId }],
      }),
    }),
  });

export const {
  useLazyGetCustomerQuery,
  useGetCustomerQuery,
  useLoyaltyDetailsQuery,
  useLazyLoyaltyDetailsQuery,
  useLazyGetCustomerPhotoQuery,
  useClaimCardMutation,
  useReplaceCardMutation,
} = loyaltySlice;
